import api from "@/router/api"

export default {
    getAllLevels2({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesLevel2.list(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_LEVELS_2', response.data.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener los niveles 2',
                    })
                })
        })
    },
    searchLevels2({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesLevel2.search(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_LEVELS_2', response.data.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener los niveles 2',
                    })
                })
        })
    },
    findLevels2({commit}, payload){

        return new Promise((resolve, reject) => {
            api.auxiliariesLevel2.find(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_LEVEL_2', response.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener los niveles 2',
                    })
                })
        })
    },

    createLevels2({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesLevel2.create(payload)
                .then(response => {
                    const {data} = response.data
                    commit('SET_LEVELS_2', response.data.data)
                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    updateLevels2({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesLevel2.update(payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    deleteLevels2({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.auxiliariesLevel2.delete(payload.id)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(() => {
                    reject({
                        message: 'Error al eliminar el nivel.',
                    })
                })
        })
    },
}